import config from "@/config.json";
import siteMeta from "../assets/site-meta.json";
import units from "../assets/units.json";

const computedPublicPath =
  process.env.NODE_ENV === `production` ? config.publicPath : "";

const computedUnits = units.filter((unit) => unit.title !== "General");

let myApp = {
  config,
  siteMeta,
  units,
  computedPublicPath,
  computedUnits,
};

export { myApp };
